import Data from '../Data';

// Action Types

export const SUGGESTIONS_LOADED = 'canny/issue_suggestions/suggestions_loaded';
export const SUGGESTIONS_ERROR = 'canny/issue_suggestions/suggestions_error';
export const INVALIDATE = 'canny/issue_suggestions/invalidate';

// Actions

function suggestionsLoaded(search, suggestions) {
  return {
    search,
    suggestions,
    timestamp: Date.now(),
    type: SUGGESTIONS_LOADED,
  };
}

function suggestionsError(search, error) {
  return {
    error,
    search,
    timestamp: Date.now(),
    type: SUGGESTIONS_ERROR,
  };
}

function invalidate() {
  return {
    timestamp: Date.now(),
    type: INVALIDATE,
  };
}

// Action Creators

function fetchSuggestions(search) {
  return (dispatch, getState) => {
    const cookies = getState().cookies;
    return Data.fetch(
      {
        suggestions: {
          input: {
            search,
          },
          query: Data.queries.issueSuggestions,
        },
      },
      cookies,
      (error, data) => {
        if (error) {
          return dispatch(suggestionsError(search, error));
        } else {
          return dispatch(suggestionsLoaded(search, data.suggestions));
        }
      },
    );
  };
}

export function loadSuggestions(search) {
  return (dispatch, getState) => {
    if (shouldFetchSuggestions(getState(), search)) {
      return dispatch(fetchSuggestions(search));
    }

    return Promise.resolve();
  };
}

export function invalidateSuggestions() {
  return (dispatch) => {
    return dispatch(invalidate());
  };
}

// Helpers

function shouldFetchSuggestions(state, search) {
  if (typeof search !== 'string' || search.length === 0) {
    return false;
  }

  const issueSuggestions = state.issueSuggestions;
  return !issueSuggestions[search];
}
